import { render } from "./Faq.m.backup.vue?vue&type=template&id=ea7444ee&scoped=true"
import script from "./Faq.m.backup.vue?vue&type=script&lang=js"
export * from "./Faq.m.backup.vue?vue&type=script&lang=js"

import "./Faq.m.backup.vue?vue&type=style&index=0&id=ea7444ee&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea7444ee"]])

export default __exports__